export type TileMediaErrorType =
  | 'MISSING_DATA' // No data available for the requested step
  | 'REQUEST_FAILED' // Network request failed (e.g. 50x errors)
  | 'TIMEOUT' // Request timed out
  | 'INVALID_DATA' // Data exists but is invalid/corrupted
  | 'UNAUTHORIZED' // Permission denied
  | 'UNKNOWN'; // Other errors

export class TileMediaError extends Error {
  constructor(
    message: string,
    public readonly type: TileMediaErrorType,
    public readonly originalError?: Error
  ) {
    super(message);
    this.name = 'TileMediaError';
  }
}

export function createTileMediaError(
  message: string,
  type: TileMediaErrorType,
  originalError?: Error
): TileMediaError {
  return new TileMediaError(message, type, originalError);
}
